import { MouseEvent, useState, useContext } from 'react'
import { Box, Divider, IconButton, Stack, Typography, Popover } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import ContactChip from './ContactChip'
import { Contact, EventDto } from '../../../interfaces/IEvent'
import EditContact from './UpdateContact'
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework'
import { enqueueSnackbar } from 'notistack'

interface ContactInfoProps {
  viewEvent: EventDto
  contact: Contact
  onUpdateEventView: (eventId: string) => void
}

export default function ContactInfo({ viewEvent, contact, onUpdateEventView }: ContactInfoProps) {
  const { context } = useContext(EbAuthenticatedAppContext)
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

  const handleClick = (event: MouseEvent<HTMLDivElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const deleteContact = async () => {
    var response = await context.restApiClient.buildRequest(`/api/event/${viewEvent.id}/contacts/${contact.id}/delete`).deleteAsync()

    if (response.error) {
      enqueueSnackbar(<Typography variant="body2">Kunne ikke slette kontakt. Prøv igjen eller kontakt systemansvarlig.</Typography>, {
        variant: 'error',
      })
    } else {
      enqueueSnackbar(<Typography variant="body2">Kontakt slettet.</Typography>, { variant: 'success' })
      handleClose()
      onUpdateEventView(viewEvent.id)
    }
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <ContactChip label={contact.name} role={contact.role} onClick={handleClick} />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box
          sx={{
            p: 2,
            maxWidth: 500,
            minWidth: 300
          }}>
          <Stack direction="row" spacing={'auto'} sx={{
            alignItems: 'center'
          }}>
            <Typography variant="body2" sx={{
              fontWeight: 600
            }}>
              {contact.name}
            </Typography>
            <Box
              sx={{
                pl: 1,
                textAlign: 'right'
              }}>
              <EditContact viewEvent={viewEvent} selectedContact={contact} onUpdateEventView={onUpdateEventView} />
              <IconButton color="error" size="small" onClick={deleteContact}>
                <DeleteOutlinedIcon fontSize="small" />
              </IconButton>
            </Box>
          </Stack>
          <Divider sx={{ mb: 2 }} />
          <Stack direction={'row'} spacing={'auto'}>
            <Typography variant="body2">Rolle: </Typography>
            <Typography variant="body2" sx={{
              pl: 1
            }}>
              {contact.role}
            </Typography>
          </Stack>
          <Stack direction={'row'} spacing={'auto'}>
            <Typography variant="body2">Telefon: </Typography>
            <Typography variant="body2" sx={{
              pl: 1
            }}>
              {contact.phone}
            </Typography>
          </Stack>
          <Stack direction={'row'} spacing={'auto'}>
            <Typography variant="body2">Epost: </Typography>
            <Typography variant="body2" sx={{
              pl: 1
            }}>
              {contact.email}
            </Typography>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
